import React from 'react';
import { ShieldCheckIcon, LockIcon, AwardIcon, UsersIcon } from 'lucide-react';
export const TrustBadges: React.FC = () => {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-200">
      <div className="flex flex-col items-center text-center" data-id="element-201">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3" data-id="element-202">
          <ShieldCheckIcon className="h-8 w-8 text-red-600" data-id="element-203" />
        </div>
        <p className="text-sm font-semibold text-gray-900" data-id="element-204">100% Confidential</p>
        <p className="text-xs text-gray-600 mt-1" data-id="element-205">
          Complete discretion guaranteed
        </p>
      </div>
      <div className="flex flex-col items-center text-center" data-id="element-206">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3" data-id="element-207">
          <LockIcon className="h-8 w-8 text-red-600" data-id="element-208" />
        </div>
        <p className="text-sm font-semibold text-gray-900" data-id="element-209">Secure Process</p>
        <p className="text-xs text-gray-600 mt-1" data-id="element-210">GDPR compliant handling</p>
      </div>
      <div className="flex flex-col items-center text-center" data-id="element-211">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3" data-id="element-212">
          <UsersIcon className="h-8 w-8 text-red-600" data-id="element-213" />
        </div>
        <p className="text-sm font-semibold text-gray-900" data-id="element-214">150+ Companies</p>
        <p className="text-xs text-gray-600 mt-1" data-id="element-215">Successfully transferred</p>
      </div>
      <div className="flex flex-col items-center text-center" data-id="element-216">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3" data-id="element-217">
          <AwardIcon className="h-8 w-8 text-red-600" data-id="element-218" />
        </div>
        <p className="text-sm font-semibold text-gray-900" data-id="element-219">24hr Response</p>
        <p className="text-xs text-gray-600 mt-1" data-id="element-220">Average response time</p>
      </div>
    </div>;
};